import React from "react";

export const Standard = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
            <path
                d="M42 53C47.4737 53 52 48.4737 52 43C52 37.5263 47.4737 33 42 33C36.5263 33 32 37.5263 32 43C32 48.4737 36.5263 53 42 53Z"
                fill="#FE9235"/>
            <path d="M39 39V47L46 42.8919L39 39Z" fill="white"/>
            <path d="M49 17V27.2105C49 29.3158 50.697 31 52.8182 31H63L49 17Z" fill="#BBBBBB"/>
            <path
                d="M22 20C22 18.8954 22.8954 18 24 18H49L62 31V64C62 65.1046 61.1046 66 60 66H24C22.8954 66 22 65.1046 22 64V20Z"
                stroke="#BBBBBB" strokeWidth="2"/>
        </svg>
    )
}
